// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2JsoQ","label":"Section_label__2i9Sn","contentWrap":"Section_contentWrap__26cht","footer":"Section_footer__G4GG2","footerInner":"Section_footerInner__2rdOc"};